<template>
  <div :class="[`x53`, className || ``]">
    <img
      class="nauka"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/nauka-1@2x.png"
      alt="nauka"
    />
    <p class="metall-trad poppins-medium-thunder-22px">
      Компания Metall-Trade.ru выступила партнером ежегодного конкурса инженерных проектов
    </p>
    <p class="text-2-1 poppins-normal-storm-dust-20px">
      Победители конкурса получат возможность пройти стажировку в исследовательском центре компании...
    </p>
    <group460 />
  </div>
</template>

<script>
import Group460 from "./Group460";
export default {
  name: "X5332",
  components: {
    Group460,
  },
  props: ["className"],
};
</script>

<style>
.x53 {
  height: 215px;
  left: 586px;
  position: absolute;
  top: 657px;
  width: 946px;
}

.nauka {
  aspect-ratio: 1.68;
  height: 215px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 362px;
  border-radius: 20px;
}

.metall-trad {
  left: 390px;
  letter-spacing: 0;
  line-height: 39.6px;
  position: absolute;
  top: 7px;
  width: 552px;
}

.text-2-1 {
  left: 390px;
  letter-spacing: 0.4px;
  line-height: 36px;
  position: absolute;
  top: 107px;
  width: 518px;
}

.x53.x52 {
  top: 410px;
}

.x53.x51 {
  top: 163px;
}
</style>
